import React from 'react'
import Ducky from '../assets/rubber-duck.svg'
import _ from 'lodash'
import styled from 'styled-components'

function RubberDucky(props) {
  return (
    <Wrapper>
      <h2>Challenge Level</h2>
      {_.times(props.difficulty, () => (
        <img className="duck" src={Ducky} alt="ducks for difficulty" />
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: block;
  h2 {
    font-size: 18px;
    color: #617d98;
  }
  .duck {
    height: 30px;
    width: 30px;
    margin-right: 12px;
    margin-bottom: 12px;
  }
  /* https://css-tricks.com/snippets/css/shake-css-keyframe-animation/ */
  .duck:hover {
    animation: shake 1.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
  }

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`

export default RubberDucky
